export function findLast<T>(array: T[], predicate: (value: T, index: number, obj: T[]) => boolean) {
    return [...array].reverse().find(predicate);
}
